var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMailSendEmailMessage = function SvgMailSendEmailMessage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-send-email-message (2) 1",
    clipPath: "url(#clip0_1889_10425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail-send-email-message--send-email-paper-airplane-deliver"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7909 0.20923C19.9904 0.40883 20.0537 0.707257 19.9524 0.97072L12.8095 19.5421C12.7062 19.8107 12.4518 19.9911 12.1641 19.9997C11.8764 20.0083 11.6117 19.8433 11.4926 19.5813L8.50551 13.0097L12.9005 8.61476C13.3189 8.19634 13.3189 7.51794 12.9005 7.09953C12.4821 6.68111 11.8037 6.68111 11.3852 7.09953L6.99027 11.4945L0.418714 8.50743C0.156701 8.38833 -0.00823687 8.12361 0.000317496 7.83593C0.00887191 7.54826 0.189249 7.2938 0.457874 7.19049L19.0293 0.0476309C19.2927 -0.0537008 19.5911 0.00962968 19.7909 0.20923Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1889_10425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMailSendEmailMessage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mail-send-email-message.0b7fde4421d2b9a7b4a8f1a0e1ff6cd7.svg";